import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import { TWITTER_URL, FACEBOOK_URL } from '../constants/SocialShare';
import RouterHelper from '../utils/RouterHelper';
import ServiceListStore from '../stores/ServiceList';
import { useManiless } from '../components/ManilessProvider';
import { trackMetric } from '../utils/trackMetric';
import {
  SOCIAL_SHARING_FACEBOOK_CTA_CLICK,
  SOCIAL_SHARING_TWITTER_CTA_CLICK,
  SOCIAL_SHARING_C2_IMPRESSION
} from '../constants/metrics';
import dataAids from '../constants/dataAids';
import { Translate as translate } from '@wsb/vnext-widget-content-translate';

function SocialSharing({ showFacebook, showTwitter, staticContent, isPublishMode }) {
  const showSocialShareIcons = showFacebook || showTwitter;

  useEffect(() => {
    if (isPublishMode && showSocialShareIcons) {
      trackMetric(SOCIAL_SHARING_C2_IMPRESSION);
    }
  }, []);

  const styles = {
    outerContainer: {
      marginTop: 'small',
      display: 'inline-flex'
    },
    wrapper: {
      cursor: isPublishMode ? 'pointer' : 'not-allowed',
      display: 'flex',
      paddingBottom: 'small',
      flexDirection: 'row'
    }
  };

  const { Block, Icon, Text } = UX2.Element;
  const interpolate = translate(staticContent);
  const { currentPageRoute } = useManiless();
  const { selectedService: service } = ServiceListStore.getState();
  const deepLink = RouterHelper.buildServicePath(service.slug, currentPageRoute);

  const handleTwitterOnClick = () => {
    if (isPublishMode) {
      trackMetric(SOCIAL_SHARING_TWITTER_CTA_CLICK);
      window.location.replace(`${TWITTER_URL}${deepLink}`);
      window.history.pushState({}, null, window.location.href);
    }
  };

  const handleFacebookOnClick = () => {
    if (isPublishMode) {
      trackMetric(SOCIAL_SHARING_FACEBOOK_CTA_CLICK);
      window.open(`${FACEBOOK_URL}${deepLink}`, 'facebook-share-dialog', 'width=510,height=424');
    }
  };

  if (!showSocialShareIcons) {
    return null;
  }

  return (
    <Text style={ styles.outerContainer } data-aid={ dataAids.SOCIAL_SHARING_WRAPPER }>
      <Text featured>{ interpolate('share') + ':' }</Text>
      <Text featured style={ styles.wrapper }>
        { showFacebook && (
          <Block onClick={ handleFacebookOnClick } data-aid={ dataAids.SOCIAL_SHARING_FACEBOOK_ICON }>
            <Icon icon='facebook' size='30' />
          </Block>
        ) }
        { showTwitter && (
          <Block
            onClick={ handleTwitterOnClick }
            data-aid={ dataAids.SOCIAL_SHARING_TWITTER_ICON }
          >
            <Icon icon='twitter' size='30' />
          </Block>
        ) }
      </Text>
    </Text>
  );
}

SocialSharing.propTypes = {
  showFacebook: PropTypes.bool,
  showTwitter: PropTypes.bool,
  isPublishMode: PropTypes.bool,
  staticContent: PropTypes.object.isRequired
};

export default SocialSharing;
